var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 0C17.7038 0 18.4987 0.32924 19.0847 0.915291C19.6708 1.50134 20 2.2962 20 3.125V13.125C20 13.9538 19.6708 14.7487 19.0847 15.3347C18.4987 15.9208 17.7038 16.25 16.875 16.25H3.125C2.2962 16.25 1.50134 15.9208 0.915291 15.3347C0.32924 14.7487 0 13.9538 0 13.125V3.125C0 2.2962 0.32924 1.50134 0.915291 0.915291C1.50134 0.32924 2.2962 0 3.125 0H16.875ZM18.75 4.95125L10.3175 9.91375C10.2378 9.96056 10.1487 9.9891 10.0566 9.99731C9.9645 10.0055 9.87175 9.99321 9.785 9.96125L9.6825 9.91375L1.25 4.95375V13.125C1.25 13.6223 1.44754 14.0992 1.79917 14.4508C2.15081 14.8025 2.62772 15 3.125 15H16.875C17.3723 15 17.8492 14.8025 18.2008 14.4508C18.5525 14.0992 18.75 13.6223 18.75 13.125V4.95125ZM16.875 1.25H3.125C2.62772 1.25 2.15081 1.44754 1.79917 1.79917C1.44754 2.15081 1.25 2.62772 1.25 3.125V3.5025L10 8.65L18.75 3.5V3.125C18.75 2.62772 18.5525 2.15081 18.2008 1.79917C17.8492 1.44754 17.3723 1.25 16.875 1.25Z",
    fill: "#EF9273"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.cf52abb0c1aa1921d42393623fbbd8a9.svg";
export { ForwardRef as ReactComponent };